/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S17_BodyInputs */

const tr_kullanim_s17_body = /** @type {(inputs: Kullanim_S17_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taraflar, Sözleşme süresince ve sona ermesinden sonra 5 (beş) yıl boyunca birbirlerinden edindikleri tüm ticari, teknik ve finansal bilgilerin gizliliğini korumakla yükümlüdür. Bu yükümlülük süresizdir.`)
};

const en_kullanim_s17_body = /** @type {(inputs: Kullanim_S17_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The parties are obliged to protect the confidentiality of all commercial, technical and financial information obtained from each other during the term of the Agreement and for 5 (five) years after its end. This obligation is indefinite.`)
};

const de_kullanim_s17_body = /** @type {(inputs: Kullanim_S17_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Parteien sind verpflichtet, während der Vertragslaufzeit und 5 (fünf) Jahre nach deren Ende die Vertraulichkeit aller voneinander erlangten geschäftlichen, technischen und finanziellen Informationen zu wahren. Diese Pflicht ist unbefristet.`)
};

const ru_kullanim_s17_body = /** @type {(inputs: Kullanim_S17_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стороны обязаны сохранять конфиденциальность всей коммерческой, технической и финансовой информации, полученной друг от друга, в течение срока действия Договора и 5 (пяти) лет после его окончания. Эта обязанность является бессрочной.`)
};

/**
* | output |
* | --- |
* | "The parties are obliged to protect the confidentiality of all commercial, technical and financial information obtained from each other during the term of the..." |
*
* @param {Kullanim_S17_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s17_body = /** @type {((inputs?: Kullanim_S17_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S17_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s17_body(inputs)
	if (locale === "de") return de_kullanim_s17_body(inputs)
	if (locale === "ru") return ru_kullanim_s17_body(inputs)
	return tr_kullanim_s17_body(inputs)
});